import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import './Dashboard.css'
import DashboardLayout from './DashboardLayout'
import Popup from '@/custom/components/organisms/Popup'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import { useFormik } from 'formik'

import SEO from '@/utils/SEO'

const SavedCard = (props) => {
    const [addCard, setAddCard] = useState(false)
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            confirm_password: '',
        },
    })
    const addCardData = [
        {
            label: 'Name',
            name: 'name',
            type: 'email',
            placeholder: 'Enter card holder name',
            class: 'col-12',
            autoFocus: true,
            formik: formik,
        },
        {
            label: 'Card number',
            name: 'card_number',
            type: 'number',
            placeholder: 'Enter card number',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Name',
            name: 'name',
            type: 'email',
            placeholder: 'Enter card holder name',
            class: 'col-12',
            autoFocus: true,
            formik: formik,
        },
        {
            label: 'CVV',
            name: 'cvv',
            type: 'text',
            placeholder: 'Enter' + ' CVV',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Expiry date',
            name: 'expiry_date',
            type: 'date',
            placeholder: 'Date of card expiration',
            class: 'col-12',
            formik: formik,
        },
    ]
    const history = useHistory()

    return (
        <>
            <DashboardLayout title={'Saved Search'}>
                <SEO title="My Saved Searches" url={window.location.href} />
                <div className="maTitle d-flex justify-content-between align-items-center w-100">
                    <Button
                        onClick={() => {
                            handleRedirectInternal(history, 'my-account')
                        }}
                        className="moveBack"
                    >
                        <span className="material-icons">keyboard_arrow_left</span>
                        {'Back to Account'}
                    </Button>
                </div>
                <div className="dashboardInner">
                    <h1 className="title mb-3">Manage Cards</h1>
                    <p className="mb-5 tagLine">
                        Zipperbuy accepts all major credit and debit cards including MasterCard,
                        Visa, and Discover.
                    </p>
                    <div className="mySavedCards">
                        <div className="emptySavedCard" onClick={() => setAddCard(true)}>
                            <img src="/assets/images/creditCard.svg" alt="Card icon" />
                            <h4>{'Add a new card'}</h4>
                            <div className="d-flex avgCards align-items-center justify-content-between mt-4">
                                <img src="/assets/images/vs.png" />
                                <img src="/assets/images/ae.png" />
                                <img src="/assets/images/mc.png" />
                                <img src="/assets/images/dc.png" />
                            </div>
                        </div>
                        <div className="filledSavedCard w">
                            <div className="row">
                                <div className="col-6 pt-1">
                                    <img src="/assets/svg/visa-pay-logo.svg" alt="bank" />
                                </div>
                            </div>
                            <div className="card-num">
                                <span>****</span>
                                <span>****</span>
                                <span>****</span>
                                <span>4051</span>
                            </div>
                            <div className="clearfix">
                                <div className="float-left">
                                    <div className="fs-12">{'Card holder'}</div>
                                    <div className="fs-12">test</div>
                                </div>
                                <div className="float-right">
                                    <div className="fs-12">{'Expires'}</div>
                                    <div className="fs-12">12 / 24</div>
                                </div>
                            </div>
                            <div className="editDel">
                                <a
                                    href="#"
                                    className="modifyCard edit"
                                    onClick={() => setAddCard(true)}
                                >
                                    Update
                                </a>
                                <a href="#" className="modifyCard delete">
                                    Remove
                                </a>
                            </div>
                        </div>
                        <div className="emptySavedCard d-flex align-items-center justify-content-center">
                            <div className="d-flex flex-column">
                                <h4>{'$26.30'}</h4>
                                <h4>{'Store Credit Balance'}</h4>
                            </div>
                        </div>
                        <Popup
                            open={addCard}
                            size="md"
                            handleClose={() => setAddCard(false)}
                            modaltitle={'Add a new card'}
                        >
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">{Object.values(mapData(addCardData))}</div>
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <PrimaryButton id="addCardData" label={'Save'} />
                                    </div>
                                </div>
                            </form>
                        </Popup>
                    </div>
                </div>
            </DashboardLayout>
        </>
    )
}

export default SavedCard
